import { useState } from 'react';
import { Link } from 'react-router-dom';
import './FAQ.css';

const QUESTIONS = [
  {
    question: 'Quelle tenue porter\u00A0?',
    reponse: 'Robes longues, costumes légers, couleurs vives et motifs floraux, mais surtout sens-toi beau·belle\u00A0!',
  },
  {
    question: 'Puis-je venir accompagné·e\u00A0?',
    reponse: 'Les accompagnant·es sont nommé·es sur ton faire-part. En cas de doute, écris-nous.',
  },
  {
    question: 'Je viens accompagné·e, une seule réponse au RSVP suffit-elle\u00A0?',
    reponse: (
      <>
        Non&nbsp;: chaque invité·e confirme sa présence individuellement en remplissant le{' '}
        <Link to="/rsvp">formulaire RSVP</Link> avec son propre prénom et nom, y compris les
        accompagnant·es.
      </>
    ),
  },
  // {
  //   question: 'Les enfants sont-ils les bienvenus ?',
  //   reponse: 'Nous adorons vos petits, mais avons choisi de réserver la fête aux adultes après la cérémonie, pour que tout le monde puisse profiter pleinement.',
  // },
  {
    question: 'Où se loger\u00A0?',
    reponse: (
      <>
        Voir la page <Link to="/voyage">«&nbsp;Voyage&nbsp;»</Link> pour les suggestions
        d'hébergement autour de Puidoux.
      </>
    ),
  },
  {
    question: 'Les cadeaux\u00A0?',
    reponse:
      'Ta présence est notre plus beau cadeau. Si tu souhaites tout de même contribuer, une cagnotte lune de miel sera disponible le jour J.',
  },
  {
    question: 'Y a-t-il un parking sur place\u00A0?',
    reponse: (
      <>
        Oui, un parking sera à disposition au Domaine de la Buritaz. Un plan est disponible à la
        page <Link to="/voyage">«&nbsp;Voyage&nbsp;»</Link>.
      </>
    ),
  },
  {
    question: 'Y aura-t-il des options végétariennes / véganes\u00A0?',
    reponse: (
      <>
        Oui — merci d'indiquer ton régime alimentaire sur le <Link to="/rsvp">formulaire RSVP</Link>.
      </>
    ),
  },
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="section container">
      <h1 className="section-title">Questions fréquentes</h1>
      <p className="section-subtitle">
        Tu as une question&nbsp;? Voici quelques réponses, mais n'hésite pas à nous contacter&nbsp;!
      </p>

      <div className="faq-list">
        {QUESTIONS.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div className={`faq-item card ${isOpen ? 'open' : ''}`} key={item.question}>
              <button className="faq-question" onClick={() => toggle(index)}>
                {item.question}
                <span className="faq-icon">{isOpen ? '−' : '+'}</span>
              </button>
              {isOpen && <p className="faq-reponse">{item.reponse}</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default FAQ;
